import { render } from "./ScpmTableSegmentV2.vue?vue&type=template&id=8182c7c0&scoped=true"
import script from "./ScpmTableSegmentV2.vue?vue&type=script&lang=js"
export * from "./ScpmTableSegmentV2.vue?vue&type=script&lang=js"

import "./ScpmTableSegmentV2.vue?vue&type=style&index=0&id=8182c7c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8182c7c0"],['__file',"src/components/scpm/common/ScpmTableSegmentV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8182c7c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8182c7c0', __exports__)) {
    api.reload('8182c7c0', __exports__)
  }
  
  module.hot.accept("./ScpmTableSegmentV2.vue?vue&type=template&id=8182c7c0&scoped=true", () => {
    api.rerender('8182c7c0', render)
  })

}


export default __exports__